import { createCrudActions } from "../utils/crudGenerator";

const formatDays = (data) => {
  if (!data) {
    return [];
  }
  const formatItem = (item) => ({
    ...item,
    label: `${item.dayNumber}`,
    value: item._id,
  });

  if (Array.isArray(data)) {
    return data.map(formatItem);
  }
  return formatItem(data);
};

export const {
  fetch: fetchDays,
  create: createDay,
  update: updateDay,
  delete: deleteDays,
} = createCrudActions("DAY", "Jornada", formatDays);
